import { render, staticRenderFns } from "./inheritLog.vue?vue&type=template&id=2e50166a&scoped=true&"
import script from "./inheritLog.vue?vue&type=script&lang=js&"
export * from "./inheritLog.vue?vue&type=script&lang=js&"
import style0 from "./inheritLog.vue?vue&type=style&index=0&id=2e50166a&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e50166a",
  null
  
)

export default component.exports